import { mapQueryToString } from "lib/build/events";

import { EventsAction } from "src/features/events/actions";
import {
	EventsState,
	EventsStateItem,
	EventsStateItemMap
} from "src/features/events/types";

const initialState: EventsState = { isLoading: false, items: {} };

export function eventsReducer(
	state: EventsState = initialState,
	action: EventsAction
): EventsState {
	if (action.type === "FETCH_EVENTS_START") {
		return { ...state, isLoading: true };
	}
	if (action.type === "FETCH_EVENTS_SUCCESS") {
		return {
			...state,
			isLoading: false,
			items: handleFetchSuccess(state.items, action.payload.items)
		};
	}
	if (action.type === "FETCH_EVENTS_FAILURE") {
		return { ...state, isLoading: false };
	}
	if (action.type === "REFETCH_EVENTS_SUCCESS") {
		return {
			...state,
			isLoading: false,
			items: handleRefetchSuccess(state.items, action.payload)
		};
	}
	return state;
}

export function handleFetchSuccess(
	itemMap: EventsStateItemMap,
	itemList: EventsStateItem[]
): EventsStateItemMap {
	const out = { ...itemMap };
	for (const item of itemList) {
		out[mapQueryToString(item.query)] = item;
	}
	return out;
}

export function handleRefetchSuccess(
	itemMap: EventsStateItemMap,
	item: EventsStateItem
): EventsStateItemMap {
	return { ...itemMap, [mapQueryToString(item.query)]: item };
}
